var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 72,
    viewBox: "0 0 71 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.3821 51.7087C63.0068 48.78 61.3564 45.0525 59.4308 41.5913C57.5055 37.8638 55.5799 34.4025 53.9295 31.2075C50.6286 25.35 45.4021 17.895 41.5509 12.57C40.1756 10.7062 37.9749 9.375 35.4994 9.375C33.0238 9.375 30.8231 10.44 29.4477 12.57C25.5967 17.895 20.6453 25.35 17.0693 31.2075C13.4933 37.3312 9.36721 45.8512 6.61646 51.7087C5.51617 53.8387 5.79124 56.5012 6.89156 58.365C8.26692 60.495 10.4675 61.56 12.9432 61.8262C19.545 62.0925 28.6225 62.625 35.4994 62.625C42.3763 62.625 51.7288 62.0925 58.0555 61.8262C60.5313 61.8262 62.7317 60.495 64.107 58.365C65.2075 56.5012 65.4827 53.8387 64.3821 51.7087ZM33.2986 31.4738C33.2986 30.4088 34.124 29.3438 35.4994 29.3438C36.8747 29.3438 37.7001 30.1425 37.7001 31.4738V42.1237C37.7001 43.1887 36.8747 44.2537 35.4994 44.2537C34.124 44.2537 33.2986 43.455 33.2986 42.1237V31.4738ZM35.4994 52.7738C34.124 52.7738 32.7487 51.4425 32.7487 50.1113C32.7487 48.78 34.124 47.4487 35.4994 47.4487C36.8747 47.4487 38.25 48.78 38.25 50.1113C38.25 51.4425 36.8747 52.7738 35.4994 52.7738Z",
    fill: "#F63C3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.926f8cbe48541a2c6100834f8043bc40.svg";
export { ForwardRef as ReactComponent };